import type { CanvasDoc, Viewport } from './types';

/** Canonical empty viewport. The persisted snapshot's viewport is irrelevant
 *  (per-user local); readers seed their own. */
export const DEFAULT_VIEWPORT: Viewport = { pan: { x: 0, y: 0 }, zoom: 1 };

/** Serialize a CanvasDoc to its JSON wire form. Pure (no DOM); decode +
 *  cf-id migration stay in the app (apps/codeframe/src/io/serialize.ts). */
export function encodeDoc(doc: CanvasDoc): string {
  return JSON.stringify(doc);
}
